import { render, staticRenderFns } from "./VariantAttributes.vue?vue&type=template&id=2be0cd0e&scoped=true"
import script from "./VariantAttributes.vue?vue&type=script&lang=js"
export * from "./VariantAttributes.vue?vue&type=script&lang=js"
import style0 from "./VariantAttributes.vue?vue&type=style&index=0&id=2be0cd0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be0cd0e",
  null
  
)

export default component.exports